import {
	GdsServiceFragment,
	OrderAdditionalServiceGdsServiceServiceType,
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment as BaggageServiceFragment,
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment as VipServiceFragment
} from '@websky/graphql';
import { OrderServiceType } from '@entities/order';
import { getIsBaggagePet } from '@shared/lib/gdsService';

export function getOrderServiceType(service: GdsServiceFragment): OrderServiceType {
	switch (service.type) {
		case OrderAdditionalServiceGdsServiceServiceType.Baggage:
			const baggageService = service as BaggageServiceFragment;

			if (getIsBaggagePet(baggageService.baggageType)) {
				return 'BaggagePet';
			}

			return service.type;
		case OrderAdditionalServiceGdsServiceServiceType.Vip:
			const vipService = service as VipServiceFragment;

			return vipService.subType as OrderServiceType;
		default:
			return service.type;
	}
}
